// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oT1Jo4GcaxUjEZQbErMr{width:492px}.CsmWZqflbzQqlIgtKRE5{align-items:flex-start;margin-top:24px}.EnEYzWhlU7YHo2FicDIJ{padding-left:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `oT1Jo4GcaxUjEZQbErMr`,
	"declaration": `CsmWZqflbzQqlIgtKRE5`,
	"textInput": `EnEYzWhlU7YHo2FicDIJ`
};
export default ___CSS_LOADER_EXPORT___;
